import { Pages, Panels, Views } from './panels/Consts';
import { createHashRouter } from '@vkontakte/vk-mini-apps-router';
import { Modals } from './Consts';

export const routes = [
  {
    path: Pages.EVENTS,
    panel: Panels.EVENTS_LIST,
    view: Views.MAIN,
  },
  {
    path: Pages.EVENTS_ARCHIVE_LIST,
    panel: Panels.EVENTS_ARCHIVE_LIST,
    view: Views.MAIN,
  },
  {
    path: Pages.INVITE,
    panel: Panels.INVITE_PANEL,
    view: Views.MAIN,
  },
  {
    path: Pages.EVENT_INFO,
    panel: Panels.EVENT_INFO,
    view: Views.MAIN,
  },
  {
    path: Pages.EVENT_SETTINGS,
    panel: Panels.EVENT_SETTINGS,
    view: Views.MAIN,
  },
  {
    path: Pages.SCAN_RECEIPTS_LIST,
    panel: Panels.SCAN_RECEIPTS_LIST_PANEL,
    view: Views.MAIN,
  },
  {
    path: Pages.SCAN_RECEIPT_PANEL,
    panel: Panels.SCAN_RECEIPT_PANEL,
    view: Views.MAIN,
  },
  {
    path: Pages.REPAYMENT_INFO,
    panel: Panels.REPAYMENT_INFO_PANEL,
    view: Views.MAIN,
  },
  {
    path: Pages.CREATE_PAYMENT,
    panel: Panels.CREATE_PAYMENT_PANEL,
    view: Views.MAIN,
  },
  {
    path: Pages.CREATE_REPAYMENT,
    panel: Panels.CREATE_REPAYMENT_PANEL,
    view: Views.MAIN,
  },
  {
    path: Pages.PAYMENT_INFO,
    panel: Panels.PAYMENT_INFO_PANEL,
    view: Views.MAIN,
  },
  {
    path: Pages.CREATE_PAYMENTS_FROM_QR_CODE,
    panel: Panels.CREATE_PAYMENTS_FROM_QR_CODE_PANEL,
    view: Views.MAIN,
  },
  {
    path: Pages.CREATE_PAYMENT_FROM_QR_CODE,
    panel: Panels.CREATE_PAYMENT_FROM_QR_CODE_PANEL,
    view: Views.MAIN,
  },
  {
    path: Pages.EDIT_PAYMENT,
    panel: Panels.EDIT_PAYMENT_PANEL,
    view: Views.MAIN,
  },
  {
    path: Pages.EDIT_REPAYMENT,
    panel: Panels.EDIT_REPAYMENT_PANEL,
    view: Views.MAIN,
  },
  {
    path: Pages.PROFILE,
    panel: Panels.PROFILE_PANEL,
    view: Views.MAIN,
  },
  {
    path: '/createEvent',
    modal: Modals.CREATE_EVENT_MODAL,
    view: Views.MAIN,
  },
  {
    path: `*`,
    panel: Panels.EVENTS_LIST,
    view: Views.MAIN,
  }
];
export const router = createHashRouter(routes);

const replace = (path, vars) => {
  for (let varIndex in vars) {
    path = path.replace(':' + varIndex, vars[varIndex]);
  }

  return path;
}

export const getRouteEventsList = () => {
  return [
    Pages.EVENTS,
    {},
    {}
  ];
}
export const getRouteEventsArchiveList = () => {
  return [
    Pages.EVENTS_ARCHIVE_LIST,
    {},
    {}
  ];
}

export const getRouteEventInfo = (eventId) => {
  return [
    replace(Pages.EVENT_INFO, {eventId}),
    {},
    {}
  ];
}

export const getRouteProfile = () => {
  return [
    Pages.PROFILE,
    {},
    {}
  ];
}

export const getRouteCreatePayment = (eventId, openPage = null, params = {}) => {
  return [
    replace(Pages.CREATE_PAYMENT, {eventId}),
    {},
    {
      state: {
        openPage,
        ...params
      },
    }
  ];
}

export const getRouteCreatePaymentFromQrCode = (eventId, name, items, date, receiptId) => {
  return [
    replace(Pages.CREATE_PAYMENT_FROM_QR_CODE, {eventId}),
    {},
    {
      state: {
        name,
        items,
        date,
        receiptId,
      }
    }
  ];
}

export const getRouteCreatePaymentsFromQrCode = (eventId, items, date, receiptId) => {
  return [
    replace(Pages.CREATE_PAYMENTS_FROM_QR_CODE, {eventId}),
    {},
    {
      state: {
        items,
        date,
        receiptId,
      }
    }
  ];
}

export const getRouteCreateRepayment = (eventId, userFrom, userTo) => {
  return [
    replace(Pages.CREATE_REPAYMENT, {eventId}),
    {},
    {
      state: {
        fromId: userFrom,
        toId: userTo,
      }
    }
  ];
}

export const getRouteEventSettings = (eventId) => {
  return [
    replace(Pages.EVENT_SETTINGS, {eventId}),
    {},
    {}
  ];
}

export const getRouteScanReceiptsList = (eventId) => {
  return [
    replace(Pages.SCAN_RECEIPTS_LIST, {eventId}),
    {},
    {}
  ];
}

export const getRouteScanReceipt = (eventId, id) => {
  return [
    replace(Pages.SCAN_RECEIPT_PANEL, {eventId, id}),
    {},
    {}
  ];
}

export const getRoutePaymentInfo = (id, eventId) => {
  return [
    replace(Pages.PAYMENT_INFO, {id, eventId}),
    {},
    {}
  ];
}

export const getRouteRepaymentInfo = (id, eventId) => {
  return [
    replace(Pages.REPAYMENT_INFO, {id, eventId}),
    {},
    {}
  ];
}

export const getRouteEditPayment = (id, eventId) => {
  return [
    replace(Pages.EDIT_PAYMENT, {id, eventId}),
    {},
    {}
  ];
}

export const getRouteEditRepayment = (id, eventId) => {
  return [
    replace(Pages.EDIT_REPAYMENT, {id, eventId}),
    {},
    {}
  ];
}
